export default "__VITE_ASSET__CXXSOUpB__"